<template>
    <main v-if="data && data.page">
        <article>
            <div class="infoBar">
                <WebsiteBreadcrumbs v-if="data?.page && data.page.themes && data.page.themes.length > 0">
                    <a>advocacy</a>
                    <NuxtLink :to="{ name: 'advocacy-theme', params: { theme: data?.page.themes[0].themes_id.url } }">{{
                        data?.page.themes[0].themes_id.title.toLowerCase() }}</NuxtLink>
                </WebsiteBreadcrumbs>
                <WebsiteBreadcrumbs v-else>
                    <NuxtLink :to="{ name: 'news' }">news</NuxtLink>
                </WebsiteBreadcrumbs>
                <div class="date baron headerText" v-if="articleDate">
                    <span>{{ articleDate.getDate().toString().padStart(2, '0') }}</span>
                    <span>{{ (articleDate.getMonth() + 1).toString().padStart(2, '0') }}</span>
                    <span>{{ articleDate.getFullYear() }}</span>
                </div>
            </div>
            <h1 class="helvetica title1">{{ data?.page?.title }}</h1>

            <div class="columns">
                <div class="bodyCont">
                    <BlockBody :body="data?.page.body" />
                </div>
                <BlockDownloads class="test" v-if="data?.page.downloads" :downloads="data?.page.downloads.map((download: any) => download.directus_files_id)" />
                <BlockTags :article="data?.page" />
            </div>
        </article>
        <BlockRelated :id="data.page.id" />
        <WebsiteFooter />
    </main>
</template>

<script lang="ts" setup>
const { getNews } = usePages();
const directusUrl = useDirectusUrl()
const route = useRoute();
const { data } = useAsyncData(`news-${route.params.slug}`, () => getNews(route.params.slug));

const articleDate = computed(() => {
    if (data.value?.page && data.value.page.article_date) return new Date(data.value.page.article_date)
    else return null
})

useSeoMeta({
    title: () => `${data.value?.page?.title} | News | EIC Federation`,
    ogTitle: () => `${data.value?.page?.title} | News | EIC Federation`,
    twitterTitle: () => `${data.value?.page?.title} | News | EIC Federation`,

    description: () => data.value?.page?.summary,
    ogDescription: () => data.value?.page?.summary,
    twitterDescription: () => data.value?.page?.summary,

    ogImage: () => data.value?.page?.cover?.id ? directusUrl + '/assets/' + data.value?.page.cover.id : undefined,
})
</script>

<style lang="scss" scoped>
main {
    article {
        padding: var(--size-padding-header) 0 var(--size-gutter-sections) 0;
        margin: 0 var(--size-margin-page);

        .infoBar {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-margin-page);

            margin-bottom: var(--size-gutter-default);
            color: var(--color-primary);

            .date {
                display: flex;
                gap: var(--size-gutter-default);
            }

        }

        h1 {
            margin-bottom: var(--size-gutter-double);
        }

        .columns {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-gutter-double) var(--size-margin-page);

            .bodyCont,
            .downloads,
            .tags {
                grid-column: 2;
            }
        }
    }
}


@media screen and (max-width: 1280px) {
    main article {
        .infoBar {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }

        .columns {
            display: flex;
            flex-direction: column;
            gap: var(--size-gutter-double);
        }
    }
}
</style>